import { FunctionComponent, useCallback, useEffect } from "react";
import { CheckIcon, CloseIcon } from "@form/components/common/icons";
import useAccount from "@/hooks/useAccount";
import useVerifyClaim from "@/hooks/useVerifyClaim";
import { Collapse } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { ArrowDownIcon } from "@/components/common/icons";
import TwitterVerify from "@/components/mint/TwitterVerify";
import DiscordVerify from "@/components/mint/DiscordVerify";
import EmailVerify from "@/components/mint/EmailVerify";
import store, { actions } from "@/stores";
import useToggleStatus from "@/hooks/useToggleStatus";
import useMintReferral from "@/hooks/useMintReferral";
import useMintType from "@/hooks/useMintType";

const VerifyAccountsStep: FunctionComponent<{
  chainId: number;
}> = ({ chainId }) => {
  const { isLogin } = useAccount();
  const { result } = useVerifyClaim();
  const { claimerMintToggleStatus, toggle } = useToggleStatus(
    "claimerMintToggleStatus"
  );

  const mintReferral = useMintReferral(chainId);

  const mintType = useMintType();

  const isSimpleMode = mintReferral.isOKX && mintType === "claimer";

  const opened = claimerMintToggleStatus.accounts;

  const toggleCard = useCallback(() => {
    toggle("accounts");
  }, [toggle]);

  const verifyed = isSimpleMode
    ? result["account_email"]
    : result["account_twitter"] &&
      result["account_discord"] &&
      result["account_email"];

  useEffect(() => {
    if (isLogin) {
      const timer = setInterval(() => {
        store.dispatch(actions.account.fetchUserInfo());
      }, 3000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [isLogin]);

  return (
    <div
      className={`claim-step-card  ${
        opened ? "border-primary bg-[rgba(235,243,255,0.3)]" : ""
      }`}
    >
      <div className="flex  cursor-pointer" onClick={toggleCard}>
        <CheckIcon
          className={`w-5 h-5 ${verifyed ? "fill-green" : ""}`}
        ></CheckIcon>
        <div className="font-semibold text-dark1 ml-2">
          <div>Verify accounts</div>
          <div
            className={`text-gray1 font-normal text-sm mt-1 ${
              opened ? "block" : "hidden"
            }`}
          >
            Verify your socials accounts and email
          </div>
        </div>
        <div className="flex-1"></div>
        <ArrowDownIcon
          className={`transition-all self-center ${opened ? "rotate-180" : ""}`}
        ></ArrowDownIcon>
      </div>
      <Collapse in={opened}>
        <div
          className="mt-4 gap-2 flex flex-col cursor-auto"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {!isSimpleMode && (
            <>
              <TwitterVerify></TwitterVerify>
              <DiscordVerify></DiscordVerify>
            </>
          )}

          <EmailVerify></EmailVerify>
        </div>
      </Collapse>
    </div>
  );
};

export default VerifyAccountsStep;
